import React from 'react';
import Icon from '@/components/ui/Icon';
import type { ValidIcon } from '@/components/ui/Icon';
import cn from '@/utils/cn';

// The colored tile the teacher-facing program resources page draws for a category
// (staffer/ProgramResources/ProgramResourceCard), at table size. Same colors, so a sysadmin sees
// what a teacher will.
const BACKGROUNDS: Record<string, string> = {
  Assessments: '#005595',
  CalendarWithStar: '#475D76',
  Civics: '#005C42',
  CloudWithQuestionMark: '#0076D6',
  People: '#008800',
  PieChart: '#8C4B6A',
  PuzzlePiece: '#522E91',
  Reading: '#247F99',
  SafetyGoggles: '#FFC50C',
  StickPerson: '#C9006B',
  Stopwatch: '#5C7A66',
  TCI: '#D67419',
  Toolbox: '#800000',
};

const FILLS: Record<string, string> = {
  SafetyGoggles: '#3C3C3C',
  TCI: 'transparent',
};

interface ResourceIconTileProps {
  className?: string;
  icon: string;
  size?: 'md' | 'sm';
}

const ResourceIconTile = ({ className, icon, size = 'sm' }: ResourceIconTileProps) => (
  <span
    aria-hidden="true"
    className={cn(
      'tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full',
      size === 'sm' ? 'tw-h-7 tw-w-7' : 'tw-h-[2.125rem] tw-w-[2.125rem]',
      className,
    )}
    style={{ backgroundColor: BACKGROUNDS[icon] ?? '#522E91' }}
  >
    <Icon fill={FILLS[icon] ?? 'white'} icon={icon as ValidIcon} size={size === 'sm' ? 14 : 18} />
  </span>
);

export default ResourceIconTile;
